<template>
  <div class="page-a4-wrapper">
    <div class="page-a4" id="invoice-pdf">
      <table class="invoice-pdf__wrapper">
        <tr class="invoice-pdf__header">
          <td v-if="legalEntity" style="padding-left: 5px">
            <p>
              <strong>ИЗВЕЩЕНИЕ № {{ selectedMonth | moment('M/YYYY') }}</strong>
              <strong style="margin-left: 10px; font-size: 10px">{{ legalEntity.name }}</strong>
            </p>
            <p>ИНН: {{ legalEntity.inn }} КПП: {{ legalEntity.kpp }} Р/с {{ legalEntity.bank_account }}
              {{ legalEntity.bank_name }} БИК: {{ legalEntity.bik }} К/сч {{ legalEntity.k_account }}</p>
            <div>
              <p style="float: left; width: 70%;">Плательщик: <strong>Иванов Иван Иванович</strong></p>
              <p style="float: right; width: 30%; text-align: right; padding-right: 5px;" class="nowrap">Лицевой счет:
                999999999</p>
              <div style="clear: both"></div>
            </div>
            <p>Адрес: {{ selectedHouse.address }}</p>
            <p style="color: #28C76F;">Благодарим за своевременную оплату счетов!</p>
            <p>Начислено в <strong>{{ selectedMonthText }} {{ selectedMonth | moment('YYYY') }}</strong>, в т.ч.за
              коммун.
              усл., потребл.в предыдущ.м-це: <strong>312.28</strong></p>
            <p>Подпись плательщика: ____________________________ ИТОГО К ОПЛАТЕ: <strong>312.28</strong></p>
          </td>
          <td style="width: 22.5%;">
          </td>
        </tr>
        <tr class="invoice-pdf__subheader">
          <td colspan="2">
            <p>Последний платеж от</p>
          </td>
        </tr>
        <tr class="invoice-pdf__devices">
          <td colspan="2" class="invoice-pdf-devices">
            <table class="invoice-pdf-devices__wrapper">
              <tbody>
              <tr>
                <td>Дата поверки и номер прибора учета</td>
                <td>
                  <p>ХВС1 / 01.01.2021</p>
                  <p>№1131115</p>
                </td>
                <td>
                  <p>ГВС1 / 01.01.2021</p>
                  <p>№1163418</p>
                </td>
              </tr>
              <tr>
                <td>Предыдущие показания:</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>Текущие показания:</td>
                <td></td>
                <td>0.00</td>
              </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr class="invoice-pdf__apartment-info">
          <td colspan="2">
            <p>Общая площадь: 66.00 м2; Количество зарегистрированных человек: 0; Фактически проживает: 0</p>
          </td>
        </tr>
        <tr class="invoice-pdf__charges">
          <td colspan="2">
            <table class="invoice-pdf-charges__wrapper">
              <thead>
              <tr>
                <th class="nowrap" style="width: 100%">Виды услуг</th>
                <th class="nowrap" style="width: 1%">Ед.Изм.</th>
                <th style="width: 1%">Объем услуг</th>
                <th style="width: 1%">Тариф</th>
                <th class="nowrap" style="width: 1%">Размер платы за услуги, руб.</th>
                <th style="width: 1%">Перерасчеты<br>всего, руб.</th>
                <th style="width: 1%">Итого к оплате за расчетный период, руб.</th>
              </tr>
              </thead>
              <tbody>
              <tr class="invoice-pdf-charges__category">
                <td colspan="10">
                  Жилищные услуги
                </td>
              </tr>
              <tr v-for="n in 9">
                <td>Сод. общ. имущ.компл.</td>
                <td>кв.м</td>
                <td>66.00</td>
                <td>18.24</td>
                <td>155.30</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr class="invoice-pdf-charges__category">
                <td colspan="10">
                  Коммунальные ресурсы в целях содержания общего имущества
                </td>
              </tr>
              <tr v-for="n in 5">
                <td>Сод. общ. имущ.компл.</td>
                <td>кв.м</td>
                <td>66.00</td>
                <td>18.24</td>
                <td>155.30</td>
                <td>-</td>
                <td>-</td>
              </tr>


              <tr class="invoice-pdf-charges__category">
                <td colspan="10">
                  Коммунальные услуги
                </td>
              </tr>
              <tr v-for="n in 5">
                <td>Сод. общ. имущ.компл.</td>
                <td>кв.м</td>
                <td>66.00</td>
                <td>18.24</td>
                <td>155.30</td>
                <td>-</td>
                <td>-</td>
              </tr>

              <tr class="invoice-pdf-charges__category">
                <td colspan="10">
                  Дополнительные услуги
                </td>
              </tr>
              <tr v-for="n in 5">
                <td>Сод. общ. имущ.компл.</td>
                <td>кв.м</td>
                <td>66.00</td>
                <td>18.24</td>
                <td>155.30</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr class="invoice-pdf-charges__total">
                <td colspan="6">
                  итого
                </td>
                <td>
                  312.28
                </td>
              </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr class="invoice-pdf__info">
          <td colspan="2">
            <table class="invoice-pdf-info__wrapper">
              <tr>
                <td :class="{'emptyBlockContent': !leftBlockContent}">
                  <text-redactor v-model="leftBlockContent" @save="saveKvTexts" :constants="invoiceConstants" />
                </td>
                <td :class="{'emptyBlockContent': !rightBlockContent}">
                  <text-redactor v-model="rightBlockContent" @save="saveKvTexts" :constants="invoiceConstants" />
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="invoice-pdf__extra-info">
          <td colspan="2" :class="{'emptyBlockContent': !mainBlockContent}">
            <text-redactor v-model="mainBlockContent" @save="saveKvTexts" :constants="invoiceConstants" />
          </td>
        </tr>
      </table>
    </div>
    <app-panel class="invoice-params">
      <div>
        <app-datepicker v-model="selectedMonth" minimum-view="month" format="MMMM yyyy" label="Месяц" />
      </div>
    </app-panel>
  </div>
</template>

<script>
import TextRedactor from "@/components/calculated-program/invoice/TextRedactor";

export default {
  name:       "Invoice",
  components: {
    TextRedactor,
  },
  data() {
    return {
      testModel:         "<del>fgsd</del> dfmghjklsdfhgiou wreht gjksfdgheiosruh jkl",
      leftBlockContent:  '',
      rightBlockContent: '',
      mainBlockContent:  '',
      invoiceConstants:  [],
      legalEntity:       null,
    };
  },
  computed:   {
    selectedHouse() {
      return this.$store.getters['appUser/selectedHouse'];
    },
    selectedHouseId() {
      return this.selectedHouse.id;
    },
    selectedMonthText() {
      let month = 'январе,феврале,марте,апреле,мае,июне,июле,августе,сентябре,октябре,ноябре,декабре'.split(',');
      let selectedMonth = (new Date(this.selectedMonth)).getMonth();
      return month[selectedMonth];
    },
    selectedMonth: {
      get() {
        return this.$store.getters['appUser/selectedDate'];
      },
      set( value ) {
        this.$store.dispatch('appUser/SET_DATE', value);
      },
    },
  },
  methods:    {
    loadLegalEntity() {
      const id = this.selectedHouse.legal_entities_id;
      this.$http.get('lentities', { params: { id } }).then(( { data } ) => {
        this.legalEntity = data;
      });
    },

    async getKvTexts() {
      try {
        let { data } = await this.$http.get('kv_text', {
          params: {
            buildings_id: this.selectedHouseId,
            month:        this.$options.filters.moment(this.selectedMonth, 'YYYY-MM'),
          },
        });

        let text1 = data.text1 || "";
        let text2 = data.text2 || "";
        let text3 = data.text3 || "";

        let needSave = false;

        if (text1.trim().length === 0 && text2.trim().length === 0 && text3.trim().length === 0) {
          let { data } = await this.$http.get('kv_text', {
            params: {
              buildings_id: this.selectedHouseId,
              month:        this.$moment(this.selectedMonth).subtract(1, 'month').format('YYYY-MM'),
            },
          });

          text1 = data.text1 || "";
          text2 = data.text2 || "";
          text3 = data.text3 || "";

          needSave = true;
        }

        this.leftBlockContent = text1;
        this.rightBlockContent = text2;
        this.mainBlockContent = text3;

        if (needSave) {
          this.$vs.notify({
            color: 'success',
            title: 'Тексты скопированы',
            text:  'Тексты скопированы с предыдущего месяца',
          });
          this.saveKvTexts();
        }
      } catch (e) {
        this.leftBlockContent = null;
        this.rightBlockContent = null;
        this.mainBlockContent = null;

        if (e.response) {
          if (e.response.status === 403) {
            this.$store.commit('SET_FORBIDDEN', true);
          }
        }
      }
    },
    async saveKvTexts() {
      try {
        this.$http.post('kv_text', {
          buildings_id: this.selectedHouseId,
          text1:        this.leftBlockContent,
          text2:        this.rightBlockContent,
          text3:        this.mainBlockContent,
          month:        this.$options.filters.moment(this.selectedMonth, 'YYYY-MM'),
        });
        this.$vs.notify({ color: 'success', title: 'Успешное сохранение', text: 'Тексты сохранены' });
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }
    },
    async getConstants() {
      try {
        let { data } = await this.$http.get('get_constants_for_kv', {
          params: {
            buildings_id: this.selectedHouseId,
            month:        this.$options.filters.moment(this.selectedMonth, 'YYYY-MM'),
          },
        });
        this.invoiceConstants = data.map(constant => ({
          title: constant.name,
          attrs: {
            'data-constant-id': constant.code,
          },
        }));
      } catch (e) {
        this.invoiceConstants = [];
      }
    },
  },
  created() {
    this.getConstants();
  },
  mounted() {
    this.getKvTexts();
    this.loadLegalEntity();
  },
  watch:      {
    selectedHouseId() {
      this.getKvTexts();
      this.getConstants();
      this.loadLegalEntity();
    },
    selectedMonth() {
      this.getKvTexts();
      this.getConstants();
    },
  },
};
</script>

<style lang="scss">
/* line-height +0.3 from pdf template */

.page-a4-wrapper {
  padding-top: 120px;
  padding-bottom: 90px;
}

.page-a4 {
  width: 210mm; /*186.8mm;*/
  min-height: 297mm; /*270.6mm;*/
  padding: 11.6mm 11.6mm 14.8mm 11.6mm;
  background: #fff;
  transform: scale(1.2);
}

@font-face {
  font-family: 'DejaVu Sans';
  src: url('~@/assets/fonts/DejavuSans/DejaVuSans.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'DejaVu Sans';
  src: url('~@/assets/fonts/DejavuSans/DejaVuSans-Bold.ttf') format('truetype');
  font-weight: bold;
  font-style: normal;
}

#invoice-pdf {
  margin: 0 auto;
  box-sizing: border-box;
  font-family: DejaVu Sans;
  letter-spacing: normal;
  color: #000;
}

#invoice-pdf * {
  box-sizing: border-box;
}

#invoice-pdf .bold {
  font-weight: 600;
}

#invoice-pdf strong {
  font-weight: 600;
}

#invoice-pdf u {
  text-decoration: underline;
}

#invoice-pdf em {
  font-style: italic;
}

#invoice-pdf p {
  margin: 0;
}

#invoice-pdf td {
  position: relative;
}

#invoice-pdf th {
  font-size: inherit;
}

#invoice-pdf .nowrap {
  white-space: nowrap;
}

#invoice-pdf table {
  border-collapse: collapse;
}

.invoice-pdf__wrapper {
  width: 100%;
  font-size: 11px;
  line-height: 1.5;
  table-layout: fixed;
}

.invoice-pdf__header td {
  border: 1px solid #000000;
}

.invoice-pdf__subheader td {
  border: 1px solid #000000;
  padding-left: 5px;
  font-size: 10px;
}

.invoice-pdf__devices > td {
  padding: 0;
  margin: 0;
  border-left: 1px solid #000000;
  border-right: 1px solid #000000;
}

.invoice-pdf-devices__wrapper {
  padding: 0;
  min-width: 80%;
  font-size: 9px;
  line-height: 1.4;
}

.invoice-pdf-devices__wrapper td {
  padding: 0 5px;
  border: 1px solid #000000;
  text-align: center;
}

.invoice-pdf-devices__wrapper tr:first-child td {
  border-top: none;
}

.invoice-pdf-devices__wrapper tr td:first-child {
  border-left: none;
  width: 25%;
  text-align: left;
}

.invoice-pdf__apartment-info td {
  padding-left: 5px;
  border-left: 1px solid black;
  border-right: 1px solid black;
  font-size: 10px;
}

.invoice-pdf__charges > td {
  padding: 0;
  margin: 0;
  border-left: 1px solid black;
  border-right: 1px solid black;
}

.invoice-pdf-charges__wrapper {
  width: 100%;
  max-width: 100%;
  font-size: 10px;
  table-layout: auto;
  line-height: 1.4;
}

.invoice-pdf-charges__wrapper thead {
  font-size: 8px;
  line-height: 1.3;
}

.invoice-pdf-charges__wrapper thead th {
  text-align: left;
  padding: 0 3px 0 5px;
  border: 1px solid black;
}

.invoice-pdf-charges__wrapper thead th:first-child {
  text-align: center;
}

.invoice-pdf-charges__wrapper td {
  border: 1px solid black;
  text-align: left;
  padding: 0 5px;
  white-space: nowrap;
}

.invoice-pdf-charges__wrapper th:first-child,
.invoice-pdf-charges__wrapper td:first-child {
  border-left: none;
}

.invoice-pdf-charges__wrapper th:last-child,
.invoice-pdf-charges__wrapper td:last-child {
  border-right: none;
}

.invoice-pdf-charges__category td {
  background: #e3e3e3;
  line-height: 1.3;
  font-weight: 600;
  text-align: center;
}

.invoice-pdf-charges__total td {
  font-weight: 600;
}

.invoice-pdf-charges__total td:first-child {
  text-align: right;
  border-right: none;
}

.invoice-pdf-charges__total td:last-child {
  border-left: none;
}

.invoice-pdf__info td {
  padding-top: 5px;

}

.invoice-pdf-info__wrapper {
  width: 100%;
}

.invoice-pdf-info__wrapper td {
  vertical-align: top;
}

.invoice-pdf-info__wrapper td:first-child {
  width: 55%;
  padding-right: 3px;
}

.invoice-pdf-info__wrapper td:last-child {
  width: 45%;
  padding-left: 3px;
}

.invoice-pdf__extra-info td {
  padding-top: 6px;
}

.invoice-pdf-info__wrapper,
.invoice-pdf__extra-info td {
  font-size: 9px;

  .redactor-focus {
    font-size: 11px;
  }
}

#invoice-pdf td > .quill-editor {
  position: absolute;
  left: -14px;
  top: -49px;
  background: #fff;
  right: -12px;
  z-index: 1;
}


#invoice-pdf .ql-container .ql-editor {
  font-family: DejaVu Sans;
  letter-spacing: normal;
  color: #000;
  font-size: 9px;
  padding: 12px 15px;
  background: #fff;
  line-height: 1.5;
}

.cursor-text:hover {
  cursor: text;
}

.invoice-params {
  position: fixed;
  right: 15px;
  top: 80px;
  margin-top: 2rem;
  width: 240px;
  @include max-width(1199px) {
    top: 64px;
  }
}
</style>
